import axios from "axios";
import { DEFAULT_TREE_LEVEL } from "../../constants/globals";

export function fetchTreeData(clientId, treeLevel = DEFAULT_TREE_LEVEL) {
  return axios.get(`/client/tree/print-tree/${clientId}`, {
    params: { tree_level: treeLevel },
  });
}
